<template>
     <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-card class="pa-2">
                    <v-layout justify-end align-center row>
                        <v-flex xs7 offset-xs3 id="transactions-frequency-title">Average Number of Transactions per Hour</v-flex>
                        <v-flex xs3 text-xs-right class="container-filters">
                            <v-layout row justify-end pr-1>
                                <div d-inline-flex>
                                    <v-btn-toggle v-model="toggleWeek" @change="toggleReportHandle" mandatory>
                                        <v-btn :style="toggleWeek == 0 ? { backgroundColor: '#1976d2' } : {}">
                                            <v-icon :style="toggleWeek == 0 ? { color: '#fff' } : { color: '#1976d2' }">mdi-numeric-7-box-multiple-outline</v-icon>
                                        </v-btn>
                                        <v-btn :style="toggleWeek == 1 ? { backgroundColor: '#1976d2' } : {}">
                                            <v-icon :style="toggleWeek == 1 ? { color: '#fff' } : { color: '#1976d2' }">mdi-numeric-5-box-multiple-outline</v-icon>
                                        </v-btn>
                                    </v-btn-toggle>
                                </div>

                                <div d-inline-flex class="ml-3">
                                    <v-btn-toggle v-model="toggleReport" @change="toggleReportHandle" mandatory>
                                        <v-btn :style="toggleReport == 0 ? { backgroundColor: '#1976d2' } : {}">
                                            <v-icon :style="toggleReport == 0 ? { color: '#fff' } : { color: '#1976d2' }">mdi-chart-bar</v-icon>
                                        </v-btn>
                                        <v-btn :style="toggleReport == 1 ? { backgroundColor: '#66bb6a' } : {}">
                                            <v-icon :style="toggleReport == 1 ? { color: '#fff' } : { color: '#66bb6a' }">mdi-arrow-down-bold</v-icon>
                                        </v-btn>
                                        <v-btn :style="toggleReport == 2 ? { backgroundColor: '#e53935' } : {}">
                                            <v-icon :style="toggleReport == 2 ? { color: '#fff' } : { color: '#e53935' }">mdi-arrow-up-bold</v-icon>
                                        </v-btn>
                                    </v-btn-toggle>
                                </div>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 mt-2>
                            <canvas ref="transactions-frequency" id="transactions-frequency" width="500" height="500"></canvas>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-container>
        </v-app>
     </v-content>
</template>

<script>
import renderTransactionsFrequency from '../charts.js';
import axios from 'axios';

export default {
        data() {
            return {
                canvas: null,
                toggleWeek: 0,
                toggleReport: 0,
                fullReport: null,
                minReport: null,
                maxReport: null,
                week: [{ value: 'full', text: 'Full Week' },
                       { value: 'working', text: 'Working Week' }]
            }
        },
        mixins: [ renderTransactionsFrequency ],
        mounted() {
            this.canvas = this.$refs['transactions-frequency'].getContext('2d');
            this.getTransactionsFrequencyReport();
            this.getTransactionsFrequencyReportMin();
            this.getTransactionsFrequencyReportMax();
        },
        methods: {
            getTransactionsFrequencyReport() {
                axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-transactions-frequency',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.fullReport = response.data[0];
                    this.renderTransactionsFrequency(this.canvas, this.fullReport, 'full')
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getTransactionsFrequencyReportMin() {
                axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-transactions-frequency-min',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.minReport = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getTransactionsFrequencyReportMax() {
                axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-transactions-frequency-max',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.maxReport = response.data
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            toggleReportHandle() {
                if(this.toggleReport == 0) {
                    if(this.toggleWeek == 0) {
                        this.renderTransactionsFrequency(this.canvas, this.fullReport, 'full')
                    }
                    else {
                        this.renderTransactionsFrequency(this.canvas, this.fullReport, 'full', true);
                    }
                    
                }
                else if(this.toggleReport == 1) {
                    this.renderTransactionsFrequency(this.canvas, this.minReport[this.toggleWeek], 'min')
                }
                else if(this.toggleReport == 2) {
                    this.renderTransactionsFrequency(this.canvas, this.maxReport[this.toggleWeek], 'max')
                }
            }
        }
}
</script>

<style>
.container-filters .v-btn-toggle .v-btn {
    opacity: 0.8;
}

#transactions-frequency-title { 
    font-size: 12px;
    font-weight: 500;
    color: rgba(0, 0, 0, .54);
}
</style>
